/* Lashthing 2026-09-15: gedrag van de losse LP-elementen op de standaard productpagina.
 * Nagebouwd uit assets/lash-configurator.js, alleen de vier stukjes die we hier nodig hebben:
 *   1. trust-strip: op mobiel een item per keer, elke 3,5 s de volgende (desktop toont alle drie);
 *   2. uitleg-tabs met de loop-clip (laadt pas in beeld, pauzeknop);
 *   3. de prijs in de koopknop, gespiegeld uit het prijsblok zodat hij meeloopt met de variant;
 *   4. de meeschuivende koopbalk, die de echte koopknop aanklikt.
 * Zonder JS blijft alles staan zoals het server-side gerenderd is; er breekt niets.
 * Rollback: dit bestand niet meer inladen in sections/main-product.liquid. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. trust-strip ---------- */
  function trustStrip() {
    var strip = document.querySelector('[data-lt-trust]');
    if (!strip) return;
    var items = strip.querySelectorAll('.lc__trust-item');
    if (items.length < 2 || reduced) return;
    var i = 0;
    setInterval(function () {
      if (window.innerWidth >= 750) return; /* desktop toont ze naast elkaar */
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  }

  /* ---------- 2. uitleg-tabs ---------- */
  function howto() {
    var root = document.querySelector('[data-lt-howto]');
    if (!root) return;

    /* De clips staan op preload="none"; de bron wordt pas toegevoegd als we hem nodig hebben. */
    function laad(v) {
      if (!v || v.dataset.ltGeladen) return;
      v.dataset.ltGeladen = '1';
      var bron = document.createElement('source');
      bron.src = v.getAttribute('data-howto-video');
      bron.type = v.getAttribute('data-howto-type') || 'video/mp4';
      v.appendChild(bron);
      v.load();
    }
    function speel(v) {
      if (!v) return;
      laad(v);
      if (reduced) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    /* 17-09 (melding Thomas): beide clips speelden zonder geluid en er was geen manier om het aan
       te zetten. Browsers starten een video alleen automatisch als hij gedempt is, dus het dempen
       zelf moet blijven; wat ontbrak was een knop. Deze zet hem aan na een tik van de klant. */
    root.querySelectorAll('.lc__howto-media').forEach(function (media) {
      if (!media.querySelector('.lc__howto-video') || media.querySelector('[data-howto-sound]')) return;
      var knop = document.createElement('button');
      knop.type = 'button';
      knop.className = 'lc__howto-sound';
      knop.setAttribute('data-howto-sound', '');
      knop.setAttribute('aria-pressed', 'false');
      knop.setAttribute('aria-label', 'Geluid aanzetten');
      knop.innerHTML =
        '<svg class="lc__howto-ico-mute" viewBox="0 0 24 24" width="18" height="18" focusable="false" aria-hidden="true">' +
        '<path d="M4 9.5h3.2L11 6v12L7.2 14.5H4z" fill="currentColor"/>' +
        '<path d="M15.5 9.5l5 5M20.5 9.5l-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>' +
        '<svg class="lc__howto-ico-sound" viewBox="0 0 24 24" width="18" height="18" focusable="false" aria-hidden="true">' +
        '<path d="M4 9.5h3.2L11 6v12L7.2 14.5H4z" fill="currentColor"/>' +
        '<path d="M15 9.4c1.2 1.1 1.2 4.1 0 5.2M17.6 7.2c2.3 2 2.3 7.6 0 9.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';
      media.appendChild(knop);
    });

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tab]');
      if (tab && root.contains(tab)) {
        var naam = tab.getAttribute('data-tab');
        root.querySelectorAll('[data-tab]').forEach(function (t) {
          var actief = t === tab;
          t.classList.toggle('is-active', actief);
          t.setAttribute('aria-selected', actief ? 'true' : 'false');
          t.tabIndex = actief ? 0 : -1;
        });
        root.querySelectorAll('[data-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== naam;
        });
        /* 17-09: de clip van het tweede tabblad werd alleen door de IntersectionObserver geladen.
           Een verborgen paneel komt nooit in beeld, dus die bron werd nooit gezet en de knop deed
           niets. Bij het wisselen laden en starten we de zichtbare clip nu zelf. */
        root.querySelectorAll('.lc__howto-video').forEach(function (v) {
          var paneel = v.closest('[data-panel]');
          if (paneel && paneel.hidden) v.pause();
          else speel(v);
        });
        return;
      }

      var geluid = e.target.closest('[data-howto-sound]');
      if (geluid) {
        var vg = geluid.parentElement.querySelector('.lc__howto-video');
        if (!vg) return;
        vg.muted = !vg.muted;
        geluid.setAttribute('aria-pressed', vg.muted ? 'false' : 'true');
        geluid.setAttribute('aria-label', vg.muted ? 'Geluid aanzetten' : 'Geluid uitzetten');
        if (!vg.muted) { vg.volume = 1; speel(vg); }
        return;
      }

      var knop = e.target.closest('[data-howto-toggle]');
      if (knop) {
        var video = knop.parentElement.querySelector('.lc__howto-video');
        if (!video) return;
        if (video.paused) { speel(video); knop.setAttribute('aria-pressed', 'false'); }
        else { video.pause(); knop.setAttribute('aria-pressed', 'true'); }
      }
    });

    /* zichtbare clip pas laden zodra hij in beeld komt */
    var videos = root.querySelectorAll('.lc__howto-video[data-howto-video]');
    if (!videos.length) return;
    if (!window.IntersectionObserver) { videos.forEach(speel); return; }
    var io = new IntersectionObserver(function (rijen) {
      rijen.forEach(function (r) { if (r.isIntersecting) { speel(r.target); io.unobserve(r.target); } });
    }, { rootMargin: '200px' });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* ---------- 3. prijs in de koopknop + 4. koopbalk ---------- */
  function prijzen() {
    var prijsblok = document.querySelector('[id^="price-"].price-and-in-stock-wrapper') ||
                    document.querySelector('.price-and-in-stock-wrapper');
    var knop = document.querySelector('.product-form__submit');
    var balk = document.querySelector('[data-lt-sticky]');
    if (!prijsblok || !knop) return;

    /* De prijs die de klant echt betaalt staat in de gekozen bundelbalk van Kaching; staat die er niet,
       dan is het gewoon de variantprijs uit het prijsblok. Zelfde opzet als de pill op starterkit-lp. */
    function lees() {
      var bar = document.querySelector('.kaching-bundles__bar--selected:not(.kaching-bundles__checkbox-upsells__upsell)');
      if (bar) {
        var bp = bar.querySelector('.kaching-bundles__bar-price');
        var bf = bar.querySelector('.kaching-bundles__bar-full-price');
        if (bp && bp.textContent.trim()) {
          var bpT = bp.textContent.trim();
          var bfT = bf ? bf.textContent.trim() : '';
          return { nu: bpT, was: bfT === bpT ? '' : bfT };
        }
      }
      var nu = prijsblok.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--last');
      var was = prijsblok.querySelector('.price__sale s.price-item--regular, s.price-item--regular');
      var nuT = nu ? nu.textContent.trim() : '';
      var wasT = was ? was.textContent.trim() : '';
      if (wasT && wasT === nuT) wasT = '';
      return { nu: nuT, was: wasT };
    }

    function vulKnop() {
      var p = lees();
      if (!p.nu) return;
      var pill = knop.querySelector('.lc__atc-pill');
      if (!pill) {
        pill = document.createElement('span');
        pill.className = 'lc__atc-pill';
        pill.innerHTML = '<s class="lc__atc-compare"></s><span class="lc__atc-price"></span>';
        var label = knop.querySelector('span:not(.lc__atc-pill)');
        if (label && label.parentElement === knop) label.insertAdjacentElement('afterend', pill);
        else knop.appendChild(pill);
      }
      /* het pijltje van de LP, achter de pill */
      if (!knop.querySelector('.lc__atc-arrow')) {
        var pijl = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        pijl.setAttribute('class', 'lc__atc-arrow');
        pijl.setAttribute('viewBox', '0 0 20 11');
        pijl.setAttribute('width', '20');
        pijl.setAttribute('height', '11');
        pijl.setAttribute('focusable', 'false');
        pijl.setAttribute('aria-hidden', 'true');
        pijl.innerHTML = '<path d="M1 5.5h17M14 1.5l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>';
        pill.insertAdjacentElement('afterend', pijl);
      }
      var c = pill.querySelector('.lc__atc-compare');
      var n = pill.querySelector('.lc__atc-price');
      c.textContent = p.was;
      c.hidden = !p.was;
      n.textContent = p.nu;
      if (balk) {
        var bp = balk.querySelector('[data-lt-sticky-price]');
        if (bp) bp.textContent = p.nu;
      }
    }

    vulKnop();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { window.requestAnimationFrame(vulKnop); });
      mo.observe(prijsblok, { childList: true, subtree: true, characterData: true });
      var bundel = document.querySelector('kaching-bundles-block') || document.querySelector('kaching-bundle');
      if (bundel) mo.observe(bundel, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    /* de bundelkiezer rendert soms pas na ons; een paar controles kosten niets */
    [600, 1500, 3000].forEach(function (ms) { window.setTimeout(vulKnop, ms); });

    if (!balk) return;
    var doel = knop.closest('product-form') || knop;
    balk.querySelector('[data-lt-sticky-atc]').addEventListener('click', function () {
      var echte = document.querySelector('.product-form__submit');
      if (echte) echte.click();
    });
    if (!window.IntersectionObserver) return;
    balk.hidden = false;

    /* 18-09 (melding Thomas: sticky is weg). De vorige versie keek of het element van Kaching in de
       pagina STOND. Dat staat er vanaf het laden al, maar die balk wordt zelf pas zichtbaar als je
       voorbij het koopvak scrolt. Boven aan een strip-, toolkit- of serumpagina hield onze balk zich
       dus weg terwijl die van Kaching er nog niet was: geen enkele koopknop in beeld. We kijken nu
       of die balk ECHT zichtbaar is. */
    function kachingZichtbaar() {
      var k = document.querySelector('kaching-bundles-sticky-atc');
      if (!k) return false;
      if (k.classList.contains('kaching-bundles-sticky-atc--visible')) return true;
      return k.getBoundingClientRect().height > 0;
    }

    var knopInBeeld = true;
    function toonBalk() {
      balk.classList.toggle('is-visible', !kachingZichtbaar() && !knopInBeeld);
    }

    new IntersectionObserver(function (rijen) {
      rijen.forEach(function (r) { knopInBeeld = r.isIntersecting; });
      toonBalk();
    }, { threshold: 0 }).observe(doel);

    /* Kaching schuift zijn balk los van onze waarnemer in beeld, dus na het scrollen even kijken.
       Pas 150 ms nadat het scrollen stilvalt, zodat het scrollen zelf soepel blijft. */
    var tik = 0;
    window.addEventListener('scroll', function () {
      if (tik) return;
      tik = window.setTimeout(function () { tik = 0; toonBalk(); }, 150);
    }, { passive: true });
    [1500, 4000].forEach(function (ms) { window.setTimeout(toonBalk, ms); });
  }

  /* ---------- 5. bezorgregel vlak boven de koopknop houden ----------
     De stijlkiezer van Globo en de bundelkiezer van Kaching worden client-side tussen de
     variantkiezer en het formulier geschoven. Op starterkit-lp staat de bezorgregel direct
     boven de knop, dus zetten we hem vlak voor <product-form>: dan staat hij onder de bundel
     en raken we het blok dat lt-style-boven-bundel.js verplaatst niet aan (anders duwen de
     twee scripts elkaar heen en weer). Een teller stopt het hoe dan ook na 30 keer. */
  var shipMoves = 0;
  function shipline() {
    if (shipMoves > 30) return;
    var regel = document.querySelector('.lc__shipline');
    var form = document.querySelector('product-form');
    if (!regel || !form || !form.parentElement) return;
    if (form.previousElementSibling !== regel) {
      shipMoves++;
      form.parentElement.insertBefore(regel, form);
    }
    /* het schaarsteblok hoort er op de LP direct boven, dus schuift mee */
    var schaars = document.querySelector('.lc__scarcity');
    if (schaars && regel.previousElementSibling !== schaars) {
      shipMoves++;
      regel.parentElement.insertBefore(schaars, regel);
    }
  }

  /* ---------- 6. keuzehulp in de lengte-dropdown ----------
     Vervangt het losse quizvak onder de lengtekiezer (verzoek Thomas 15-09-2026).
     Het percentage is gemeten, niet verzonnen: van alle losse lengtekeuzes in de laatste
     90 dagen (10.567 stuks, peildatum 15-09-2026) ging 45% naar 12 mm, 38% naar 10 mm en
     18% naar 14 mm. Bijwerken = LENGTE_HINT en LENGTE_TOP hieronder. */
  var LENGTE_TOP = '12MM';
  var LENGTE_HINT = 'Twijfel je? 45% kiest 12 mm';

  function lengteHint() {
    var groepen = document.querySelectorAll('.swatch--gl');
    for (var i = 0; i < groepen.length; i++) {
      var g = groepen[i];
      var legend = g.querySelector('.name-option');
      var naam = legend ? (legend.getAttribute('data-name') || legend.textContent) : '';
      if (!/lengte/i.test(naam)) continue;

      var lijst = g.querySelector('ul.ul-globo-dropdown-option');
      if (lijst && !lijst.querySelector('.lt-lenhint')) {
        var li = document.createElement('li');
        li.className = 'lt-lenhint';
        li.setAttribute('aria-hidden', 'true');
        li.textContent = LENGTE_HINT;
        lijst.insertBefore(li, lijst.firstChild);
      }
      if (lijst) {
        var opties = lijst.querySelectorAll('li.swatches-options');
        for (var j = 0; j < opties.length; j++) {
          var inp = opties[j].querySelector('input');
          var lab = opties[j].querySelector('label');
          if (!inp || !lab) continue;
          if ((inp.value || '').toUpperCase() !== LENGTE_TOP) continue;
          if (lab.querySelector('.lt-lentag')) continue;
          var tag = document.createElement('span');
          tag.className = 'lt-lentag';
          tag.textContent = 'meest gekozen';
          lab.appendChild(tag);
        }
      }
    }
  }

  /* ---------- 7. ontwerpvoorbeeld van de schaarsteteller ----------
     Thomas wil het blok met een gevulde balk kunnen beoordelen. Dit percentage is NIET gemeten
     en mag dus nooit bij een klant terechtkomen. Daarom wordt het alleen gezet zolang dit thema
     NIET het live thema is (Shopify.theme.role !== 'main'). Publiceer je de werk-kopie, dan valt
     hij automatisch terug op de echte teller uit main-product.liquid: (baseline - voorraad) /
     baseline. Dat is precies waar de LP-instelling scarcity_preview_force_pct voor bedoeld was,
     maar dan zonder de kans dat hij per ongeluk meegepubliceerd wordt.
     Uitzetten: PREVIEW_PCT op 0. */
  var PREVIEW_PCT = 93;

  function schaarstePreview() {
    if (!PREVIEW_PCT) return;
    var th = window.Shopify && window.Shopify.theme;
    if (!th || th.role === 'main') return;
    var rij = document.querySelector('.lc__scarcity-row--today');
    if (!rij || rij.getAttribute('data-lt-preview')) return;
    rij.setAttribute('data-lt-preview', String(PREVIEW_PCT));
    rij.style.setProperty('--lc-sold', PREVIEW_PCT + '%');
    var sold = rij.querySelector('.lc__scarcity-sold');
    if (sold) {
      sold.textContent = PREVIEW_PCT + '% verkocht';
      sold.hidden = false;
    }
  }

  /* ---------- 8. blokken laten binnenkomen ----------
     Verzoek Thomas: de vertrouwensblokken mogen levendiger. Een rustige fade-en-stijg zodra het
     blok in beeld komt, een keer per blok. Het attribuut wordt hier gezet en niet in de liquid,
     zodat er zonder JS nooit iets onzichtbaar blijft. Respecteert prefers-reduced-motion. */
  var REVEAL = ['.lt-garantie__kaart', '.lc__scarcity', '.lc__klarna', '.lc__wearers', '.lc__howto'];

  function reveal() {
    if (reduced || !window.IntersectionObserver) return;
    var els = [];
    REVEAL.forEach(function (sel) {
      var e = document.querySelector(sel);
      if (e && !e.hasAttribute('data-lt-reveal')) { e.setAttribute('data-lt-reveal', ''); els.push(e); }
    });
    if (!els.length) return;
    var io = new IntersectionObserver(function (rijen) {
      rijen.forEach(function (r) {
        if (!r.isIntersecting) return;
        r.target.classList.add('is-in');
        io.unobserve(r.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // 17-09 (opdracht Thomas): de omlijning van het garantievak moet uit precies vier balkjes bestaan,
  // een per zijde. pathLength=100 helpt niet: de svg wordt uitgerekt en de lijn heeft een
  // non-scaling-stroke, waardoor de browser de echte lengte gebruikt. Die meten we hier en delen
  // we door vier, zodat het op elk schermformaat klopt.
  // 17-09 (correctie Thomas): twee balken in plaats van vier, en langer. Vier was te druk.
  var RAND_BALKEN = 2, RAND_DEEL = 0.72;
  function randBalken() {
    var lijnen = document.querySelectorAll('.lt-garantie__rand-lijn');
    for (var i = 0; i < lijnen.length; i++) {
      var lijn = lijnen[i], lengte = 0;
      try { lengte = lijn.getTotalLength(); } catch (e) { continue; }
      if (!lengte) continue;
      var periode = lengte / RAND_BALKEN;
      var balk = periode * RAND_DEEL;
      lijn.style.setProperty('--lt-balk', balk.toFixed(2));
      lijn.style.setProperty('--lt-gat', (periode - balk).toFixed(2));
      lijn.style.setProperty('--lt-periode', periode.toFixed(2));
      // een cyclus loopt over twee zijden; dit keerpunt ligt precies op de hoek ertussen
      lijn.style.setProperty('--lt-halve-periode', (periode / 2).toFixed(2));
      /* 17-09: faseverschuiving. Het pad van de rect begint op de bovenrand, op x + rx, dus een
       * balkrand die op dashoffset 0 stilvalt parkeert net rechts van de linkerbovenhoek. We
       * rekenen uit waar de eerste hoek op het pad ligt (rechte zijde + halve boog) en schuiven
       * de reis zo op dat de balkranden op het traagste moment op de hoeken staan. */
      var w = 0, h = 0, rx = 0, ry = 0;
      try {
        w = lijn.width.baseVal.value; h = lijn.height.baseVal.value;
        rx = lijn.rx.baseVal.value; ry = lijn.ry.baseVal.value;
      } catch (e2) { w = 0; }
      var fase = 0;
      if (w && h) {
        var rechtX = Math.max(0, w - 2 * rx), rechtY = Math.max(0, h - 2 * ry);
        var boog = Math.max(0, (lengte - 2 * rechtX - 2 * rechtY) / 4);
        var eersteHoek = rechtX + boog / 2;
        fase = ((periode - (eersteHoek % periode)) % periode + periode) % periode;
      }
      lijn.style.setProperty('--lt-reis-start', (periode + fase).toFixed(2));
      lijn.style.setProperty('--lt-reis-half', (periode / 2 + fase).toFixed(2));
      lijn.style.setProperty('--lt-reis-eind', fase.toFixed(2));
    }
  }

  function start() {
    trustStrip();
    randBalken();
    howto();
    prijzen();
    shipline();
    lengteHint();
    schaarstePreview();
    reveal();
    if (window.MutationObserver) {
      var info = document.querySelector('.product__info-container');
      if (info) new MutationObserver(function () { window.requestAnimationFrame(function () { shipline(); lengteHint(); }); }).observe(info, { childList: true, subtree: true });
    }
    [400, 1200, 2500, 5000].forEach(function (ms) { window.setTimeout(shipline, ms); window.setTimeout(lengteHint, ms); window.setTimeout(schaarstePreview, ms); });
    var randTimer;
    window.addEventListener('resize', function () {
      clearTimeout(randTimer);
      randTimer = setTimeout(randBalken, 200);
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
